import React from 'react';
import { Route } from 'react-router-dom';
import RoutingManager from './routing-manager';
import Dashboard from './../pages/dashboard/dashboard.container';
import Profile from './../pages/profile/profile.container';
import RolesAndPermissions from './../pages/roles-and-permissions/roles-and-permissions.container';
import UserManagement from './../pages/user-management/user-management.container';
import Settings from './../pages/settings/settings.container';
import Team from './../pages/team/team.container';
import PaymentList from './../pages/payments/payments.container';
import ChargebackList from './../pages/chargebacks/chargebacks.container';
import MerchantChargesList from './../pages/merchant-charges/merchant-charges.container';
import InternalTransfersList from './../pages/internal-transfers/internal-transfers.container';
import PayoutsList from './../pages/payouts/payouts.container';
import GfoPaymentsList from '../pages/gfo-payments/gfo-payments.container';
import VirtualTerminal from './../pages/virtual-terminal/virtual-terminal.container';
import CardDetails from './../pages/card-details/card-details.container';
import AcceptInvitation from './../pages/accept-invitation/accept-invitation.container';
import AdminDashboard from './../pages/admin/dashboard/admin-dashboard.container';
import PendingCustomers from './../pages/admin/pending-customers/pending-customers.container';
import UpdateBank from './../pages/update-bank/update-bank.container';
import UpdateAccount from './../pages/update-account/update-account.container';
import GenericQRCode from '../pages/generic-qr-code/generic-qr-code.container';
import PaymentQRCode from '../pages/payment-qr-code/payment-qr-code.container';
import UpdatePassword from './../pages/update-password/update-password.container';
import AccountVerifyUploadDocuments from './../pages/account-verify-upload-documents/account-verify-upload-documents.container';
import PaymentDetails from 'pages/payment-details/payment-details.container';
import PayoutDetails from 'pages/payout-details/payout-details.container';
import AdminFunctions from 'pages/admin/admin-functions/admin-functions.container';
import PdqTransactions from 'pages/pdq-transactions/pdq-transactions.container';
import { AdminFunctionsProvider } from 'contexts';
import AdminUserTypeRoute from './admin-user-type-route';
import RestrictedAdminUserTypeRoute from './restricted-admin-user-type-route';
import LoggedRoute from './logged-route';
import WorkingAccountRoute from './working-account-route';
import TransactionPageAccessibilityRoute from './transaction-page-accessibility-route';
import MerchantManager from './merchant-routing-manager';
import ManageProducts from 'pages/manage-products/manage-products.container';
import BunkAccountUploadingDocumentsContainer from 'pages/bank-verification-upload-documents/bank-verification-upload-documents.container';
import AdminPendingMerchants from 'pages/admin/admin-pending-merchants/admin-pending-merchants.container';
import OwnerAndActiveMerchantOrAdminRoute from './owner-and-active-merchant-route';
import OwnerOrAdminRoute from './owner-or-admin-route';
import DashboardReseller from 'pages/dashboard-reseller/dashboard-reseller.container';
import ClientRegister from 'pages/client-registration/client-registration.container';
import StripePayoutDetails from 'pages/stripe-payouts-details/stripe-payout-details.container';
import MerchantDetails from 'pages/merchant-details/merchant-details.container';
import CanonicalResellerOnboarding from 'pages/canonical-reseller-onboarding/canonical-reseller-onboarding.container';
import canonicalResellerMerchant from 'pages/canonicalResellerMerchant/canonical-reseller-merchant.container';
import CanonicalResellerMerchantManagement from 'pages/canonical-reseller-merchant-management/canonical-reseller-merchant-management.container';
import SettingTermsAndConditions from 'pages/settings-terms-and-conditions/settings-terms-and-conditions.container';
import DocumentManagement from 'pages/admin/document-management/document-management.container';
import AdminMissingMerchantContainer from 'pages/admin/admin-missing-merchant/admin-missing-merchant.container';
import MissingDocument from 'pages/admin/missing-merchant-docoument/missing-merchant-document.container';
import DashboardPdq from 'pages/dashboard-pdq/dashboard-pdq.container';
import PdqOrderMerchantsContainer from 'pages/pdq-order-merchant/pdq-order-merchant.container';
import ProductApprovedRoute from './product-approved-route';
import { ProductsRequired } from 'utils/enums/ProductsRequired';
import RefundList from 'pages/refund-list/list-refund.container';
import ContractDetails from 'pages/contract-details/contract-details.container';
import PrintAgreementContainer from 'pages/print-agreement/print-agreement.container';
import BankErrorList from 'pages/bank-error-list/bank-error-list.container';
import PayoutsNotReceived from 'pages/payout-not-recieved/payout-not-received.container';

import ChargeBacks from 'pages/chargeback-list/chargeback.list.container';
export default [
    <RoutingManager
        key="home"
        path="/:resellerUrl/home"
        merchantComponent={Dashboard}
        resellerComponent={DashboardReseller}
        pdqComponent={DashboardPdq}
    ></RoutingManager>,
    <MerchantManager key="profile" path="/:resellerUrl/profile" component={Profile} />,
    <MerchantManager key="roles-permissions" path="/:resellerUrl/roles-permissions" component={RolesAndPermissions} />,
    <MerchantManager key="users" path="/:resellerUrl/users" component={UserManagement} />,
    <WorkingAccountRoute key="settings" path="/:resellerUrl/settings" component={Settings} />,
    <LoggedRoute key="team" path="/:resellerUrl/team" component={Team} />,
    <LoggedRoute key="canonical-reseller" path="/:resellerUrl/create-merchant" component={canonicalResellerMerchant} />,
    <WorkingAccountRoute key="payment-list" path="/:resellerUrl/payments/:via/:date" component={PaymentList} />,
    <WorkingAccountRoute
        key="chargeback-list"
        path="/:resellerUrl/chargebacks/:via/:date"
        component={ChargebackList}
    />,
    <WorkingAccountRoute key="merchant-pdq" path="/:resellerUrl/merchantpdq" component={DashboardPdq} />,
    <WorkingAccountRoute
        key="merchant-charges-list"
        path="/:resellerUrl/merchant-charges/:via/:date"
        component={MerchantChargesList}
    />,
    <WorkingAccountRoute key="payouts-list" path="/:resellerUrl/payouts/:via/:date" component={PayoutsList} />,
    <WorkingAccountRoute
        key="gfoPayments-list"
        path="/:resellerUrl/gfo-payments/:via/:date"
        component={GfoPaymentsList}
    />,

    <TransactionPageAccessibilityRoute
        key="internal-transfers-list"
        path="/:resellerUrl/internal-transfers/:via/:date"
        component={InternalTransfersList}
    />,
    <ProductApprovedRoute
        key="pdq-transactions"
        path="/:resellerUrl/pdq-transactions/:via/:date"
        component={PdqTransactions}
        productName={ProductsRequired.PDQ}
    />,
    <ProductApprovedRoute
        key="vt"
        exact
        path="/:resellerUrl/virtual-terminal"
        component={VirtualTerminal}
        productName={ProductsRequired.Virtual_Terminal}
    />,
    <ProductApprovedRoute
        key="cardDetails"
        path="/:resellerUrl/card-details"
        component={CardDetails}
        productName={ProductsRequired.Virtual_Terminal}
    />,
    <Route key="acceptInvitation" path="/:resellerUrl/accept-invitation" component={AcceptInvitation} />,
    <WorkingAccountRoute key="update-password" path="/:resellerUrl/update-password" component={UpdatePassword} />,

    <OwnerOrAdminRoute
        key="accountVerifyUploadDocuments"
        path="/:resellerUrl/upload-documents"
        component={AccountVerifyUploadDocuments}
    />,
    <WorkingAccountRoute
        key="accountVerifyUploadDocuments"
        path="/:resellerUrl/upload-bank-documents"
        component={BunkAccountUploadingDocumentsContainer}
    />,
    <WorkingAccountRoute key="payment-details" path="/:resellerUrl/payment-details/:id" component={PaymentDetails} />,
    <WorkingAccountRoute key="payout-details" path="/:resellerUrl/payout-details/:id" component={PayoutDetails} />,
    <LoggedRoute
        key="stripe-payout-details"
        path="/:resellerUrl/stripe-payout-details/:id"
        component={StripePayoutDetails}
    />,
    <WorkingAccountRoute
        key="setting-terms-and-conditions"
        path="/:resellerUrl/setting-terms-and-conditions"
        component={SettingTermsAndConditions}
    />,

    <AdminFunctionsProvider key="admin-functions" path="/:resellerUrl/admin-functions/:merchantId">
        {/* <AdminUserTypeRoute path="/:resellerUrl/admin-functions/:merchantId" component={AdminFunctions} /> */}
        <RestrictedAdminUserTypeRoute path="/:resellerUrl/admin-functions/:merchantId" component={AdminFunctions} />
    </AdminFunctionsProvider>,
    <AdminFunctionsProvider key="print-agreement" path="/:resellerUrl/print-agreement">
        <RestrictedAdminUserTypeRoute path="/:resellerUrl/print-agreement" component={PrintAgreementContainer} />
    </AdminFunctionsProvider>,
    <AdminFunctionsProvider key="bank-error-list" path="/:resellerUrl/bank-error-list">
        <AdminUserTypeRoute path="/:resellerUrl/bank-error-list" component={BankErrorList} />
    </AdminFunctionsProvider>,
    <AdminFunctionsProvider key="admin-pending-merchants" path="/:resellerUrl/admin-pending-merchants">
        <AdminUserTypeRoute component={AdminPendingMerchants} />
    </AdminFunctionsProvider>,
    <AdminFunctionsProvider key="admin-missing-merchant" path="/:resellerUrl/admin-missing-merchant">
        <AdminUserTypeRoute component={AdminMissingMerchantContainer} />
    </AdminFunctionsProvider>,
    <AdminFunctionsProvider key="missing-merchant-document" path="/:resellerUrl/missing-merchant-document/:merchantId">
        <AdminUserTypeRoute path="/:resellerUrl/missing-merchant-document/:merchantId" component={MissingDocument} />
    </AdminFunctionsProvider>,
    <AdminFunctionsProvider key="client-register" path="/:resellerUrl/client-register">
        <AdminUserTypeRoute component={ClientRegister} />
    </AdminFunctionsProvider>,
    <AdminFunctionsProvider key="merchantDetails" path="/:resellerUrl/merchant-details/:merchantId">
        <LoggedRoute path="/:resellerUrl/merchant-details/:merchantId" component={MerchantDetails} />
    </AdminFunctionsProvider>,
    <AdminFunctionsProvider key="canonicalResellerOnboarding" path="/:resellerUrl/canonical-reseller-onboarding">
        <AdminUserTypeRoute component={CanonicalResellerOnboarding} />
    </AdminFunctionsProvider>,
    <AdminFunctionsProvider
        key="canonicalResellerMerchantManagement"
        path="/:resellerUrl/canonical-reseller-merchant-management/:canonicalResellerId"
    >
        <AdminUserTypeRoute
            path="/:resellerUrl/canonical-reseller-merchant-management/:canonicalResellerId"
            component={CanonicalResellerMerchantManagement}
        />
    </AdminFunctionsProvider>,
    <AdminFunctionsProvider key="document-management" path="/:resellerUrl/document-management/:merchantId">
        <RestrictedAdminUserTypeRoute
            path="/:resellerUrl/document-management/:merchantId"
            component={DocumentManagement}
        />
    </AdminFunctionsProvider>,
    <AdminFunctionsProvider key="pdq-order-merchant" path="/:resellerUrl/pdq-order-merchant/:merchantId">
        <LoggedRoute path="/:resellerUrl/pdq-order-merchant/:merchantId" component={PdqOrderMerchantsContainer} />
    </AdminFunctionsProvider>,
    <AdminFunctionsProvider key="refund-list" path="/:resellerUrl/refund-list/:via/:date">
        <LoggedRoute path="/:resellerUrl/refund-list/:via/:date" component={RefundList} />
    </AdminFunctionsProvider>,
    <AdminFunctionsProvider key="chargebacks" path="/:resellerUrl/list-chargebacks/:via/:date">
        <AdminUserTypeRoute path="/:resellerUrl/list-chargebacks/:via/:date" component={ChargeBacks} />
    </AdminFunctionsProvider>,
    <AdminFunctionsProvider key="contract-details" path="/:resellerUrl/contract-details">
        <RestrictedAdminUserTypeRoute component={ContractDetails} />
    </AdminFunctionsProvider>,
    <AdminFunctionsProvider key="payouts-not-received" path="/:resellerUrl/payouts-not-received">
        <AdminUserTypeRoute path="/:resellerUrl/payouts-not-received" component={PayoutsNotReceived} />
    </AdminFunctionsProvider>,

    // <OwnerAndActiveMerchantOrAdminRoute key="update-bank" path="/:resellerUrl/update-bank" component={UpdateBank} />,

    <OwnerAndActiveMerchantOrAdminRoute key="update-bank" path="/:resellerUrl/update-bank" component={UpdateBank} />,
    <OwnerAndActiveMerchantOrAdminRoute
        key="update-account"
        path="/:resellerUrl/update-account"
        component={UpdateAccount}
    />,
    <OwnerAndActiveMerchantOrAdminRoute
        key="generic-qr-code"
        path="/:resellerUrl/generic-qr-code"
        component={GenericQRCode}
    />,
    <OwnerAndActiveMerchantOrAdminRoute
        key="payment-qr-code"
        path="/:resellerUrl/payment-qr-code"
        component={PaymentQRCode}
    />,

    <OwnerAndActiveMerchantOrAdminRoute
        key="manage-products"
        path="/:resellerUrl/manage-products"
        component={ManageProducts}
    />,

    <LoggedRoute key="admin" path="/:resellerUrl/admin" component={AdminDashboard} />,
    <LoggedRoute key="pending-customers" path="/:resellerUrl/pending-customers" component={PendingCustomers} />
];
